import React from 'react'
import { Modal, Grid } from 'semantic-ui-react'


import { useTranslation } from 'react-i18next'
import ModalWithCatastrophicFailureErrorBoundary from '../../../../../../../common-components/semanticUiCustomComponents/componentsWithCatastrophicFailureErrorBoundary/ModalWithCatastrophicFailureErrorBoundary'
import TextAsPseudoLink from '../../../../../../../common-components/TextAsPseudoLink'

import {
  getInfoDefinitionsOutboundEmptyKegShipmentFullDetails,
} from '../../../../util/shipmentHistory/outboundEmptyKegShipmentHistory'

// import {
//   determineItemSkuIdsToIncludeAsFieldsInShipmentsHistoryTable,
// } from '../../../../util/shipmentHistory/common/util'

import HistoryLabelWithContainerTypesDifferencesPopupIfNecessary from '../../../../util/HistoryLabelWithContainerTypesDifferencesPopupIfNecessary'
import PrintBOL from '../../../../ScheduledShipmentsHistory/Table/subFeatures/ShipmentDetails/printBOL'


export default ({
  itemSkuIdsToIncludeAsFieldsInTable,
  entireItemSkusSlice,
  customerId,
  info: shipmentDetails,
  configuredItemSkuIds,
  allOutboundEmptyKegShipmentObjects,
  entireCustomersSlice,
  dispatch,
}) => {
  const { t: translate } = useTranslation('common')
  return (
    <ModalWithCatastrophicFailureErrorBoundary // CODE_COMMENTS_131
      closeIcon
      size="large"
      trigger={<TextAsPseudoLink>{shipmentDetails.shipmentId}</TextAsPseudoLink>}
      className="test-full-shipment-details"
    >
      <Modal.Header>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>{translate('Shipment Details')}</span>
          <PrintBOL dispatch={dispatch} shipmentId={shipmentDetails.id} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <AdditionalShipmentDetails
          entireCustomersSlice={entireCustomersSlice}
          entireItemSkusSlice={entireItemSkusSlice}
          customerId={customerId}
          shipmentDetails={shipmentDetails}
          configuredItemSkuIds={configuredItemSkuIds}
          allOutboundEmptyKegShipmentObjects={allOutboundEmptyKegShipmentObjects}
          itemSkuIdsToIncludeAsFieldsInTable={itemSkuIdsToIncludeAsFieldsInTable}
        />
      </Modal.Content>
    </ModalWithCatastrophicFailureErrorBoundary>
  )
}

const AdditionalShipmentDetails = ({
  entireItemSkusSlice,
  customerId,
  shipmentDetails,
  // configuredItemSkuIds,
  // allOutboundEmptyKegShipmentObjects,
  itemSkuIdsToIncludeAsFieldsInTable,
  entireCustomersSlice,
}) => {
  // const itemSkuIdsToIncludeAsFieldsInTable = determineItemSkuIdsToIncludeAsFieldsInShipmentsHistoryTable({
  //   entireItemSkusSlice,
  //   configuredItemSkuIds,
  //   shipments: allOutboundEmptyKegShipmentObjects,
  // })

  const toDisplay = getInfoDefinitionsOutboundEmptyKegShipmentFullDetails({
    entireItemSkusSlice,
    itemSkuIdsToIncludeAsFieldsInTable,
    entireCustomersSlice,
    customerId,
  })

  const rowElements = [] // React 16-style array of React elements

  toDisplay.forEach(definition => {
    if (!definition.displayCondition || definition.displayCondition(shipmentDetails)) {
      rowElements.push(
        <Grid.Row key={definition.heading} className="compact-grid-row">
          <Grid.Column width={3} style={{ fontWeight: 'bold' }}>
            <HistoryLabelWithContainerTypesDifferencesPopupIfNecessary
              customerId={customerId}
              labelText={definition.heading}
              colonAfterText
            />
          </Grid.Column>
          <Grid.Column width={13}>{definition.cellContent(shipmentDetails)}</Grid.Column>
        </Grid.Row>,
      )
    }
  })

  return (
    // For alignment purposes, all displayed content within this grid needs to
    // be contained within a <Grid.Column> component; see CODE_COMMENTS_97 for
    // why.
    <Grid columns={2}>
      {rowElements}
    </Grid>
  )
}
